import i18n from 'Lib/i18n'
import { createDefaultReturnProxy } from './proxy'

export const translationsObject: Record<string, string> = i18n.t('apiErrors', {
  ns: 'errors',
  returnObjects: true,
})

export const translationLookUp = createDefaultReturnProxy<string>(
  translationsObject,
  translationsObject['GENERIC_ERROR']
)
